import React, { useEffect, useState, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X, Zap, Clock, TrendingUp, Star, CheckCircle2 } from 'lucide-react';
type Promo = {
  icon: React.ElementType;
  title: string;
  message: string;
};
const promos: Promo[] = [{
  icon: Star,
  title: 'Carlos M. acaba de ordenar',
  message: 'Su website estará listo en menos de 72 horas.'
}, {
  icon: Clock,
  title: 'Cupos limitados esta semana',
  message: 'Solo aceptamos pocos proyectos para entregar rápido.'
}, {
  icon: Zap,
  title: 'Empieza con solo $125',
  message: '50% adelantado, el resto cuando entregamos tu website.'
}, {
  icon: TrendingUp,
  title: 'Más clientes encontrándote',
  message: 'Un website profesional te da credibilidad al instante.'
}, {
  icon: CheckCircle2,
  title: 'Sin contratos ni mensualidades',
  message: 'Un solo pago. Tu website es tuyo para siempre.'
}];
const WHATSAPP_URL = 'https://wa.me/447311754270?text=WEBSITE';
const VISIBLE_MS = 6500;
const HIDDEN_MS = 9000;
const FIRST_DELAY_MS = 4000;
export function PromoPopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [closed, setClosed] = useState(false);
  const timers = useRef<number[]>([]);
  const clearTimers = () => {
    timers.current.forEach(t => clearTimeout(t));
    timers.current = [];
  };
  useEffect(() => {
    if (closed) {
      clearTimers();
      setOpen(false);
      return;
    }
    let i = 0;
    const showNext = (delay: number) => {
      const showTimer = window.setTimeout(() => {
        setIndex(i % promos.length);
        setOpen(true);
        const hideTimer = window.setTimeout(() => {
          setOpen(false);
          i += 1;
          showNext(HIDDEN_MS);
        }, VISIBLE_MS);
        timers.current.push(hideTimer);
      }, delay);
      timers.current.push(showTimer);
    };
    showNext(FIRST_DELAY_MS);
    return clearTimers;
  }, [closed]);
  const promo = promos[index];
  const Icon = promo.icon;
  return <AnimatePresence data-id="element-381">
      {open && !closed && <motion.div initial={{
      opacity: 0,
      x: -40,
      y: 10
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -40
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 22
    }} className="fixed bottom-5 left-5 z-50 w-[300px] max-w-[calc(100vw-2.5rem)]" data-id="element-382">
          <div className="relative bg-dark-100 border border-gold/30 rounded-2xl p-4 pr-9 shadow-[0_12px_40px_rgba(0,0,0,0.6)] overflow-hidden" data-id="element-383">
            {/* subtle gold glow */}
            <div className="absolute -top-8 -right-8 w-24 h-24 bg-gold/10 rounded-full blur-2xl pointer-events-none" data-id="element-384" />

            <button onClick={() => setClosed(true)} aria-label="Cerrar notificación" className="absolute top-2.5 right-2.5 text-gray-500 hover:text-white transition-colors" data-id="element-385">
              <X className="w-4 h-4" data-id="element-386" />
            </button>

            <div className="relative flex items-start gap-3" data-id="element-387">
              <div className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-xl bg-gold/15 text-gold" data-id="element-388">
                <Icon className="w-5 h-5" data-id="element-389" />
              </div>
              <div className="min-w-0" data-id="element-390">
                <p className="text-white font-bold text-sm leading-tight" data-id="element-391">
                  {promo.title}
                </p>
                <p className="text-gray-400 text-xs mt-0.5 leading-snug" data-id="element-392">
                  {promo.message}
                </p>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-block mt-2 text-xs font-bold text-gold hover:text-gold-400 transition-colors" data-id="element-393">
                  Quiero el mío →
                </a>
              </div>
            </div>

            {/* progress bar */}
            <motion.div key={index} initial={{
          scaleX: 1
        }} animate={{
          scaleX: 0
        }} transition={{
          duration: VISIBLE_MS / 1000,
          ease: 'linear'
        }} className="absolute bottom-0 left-0 h-0.5 w-full bg-gold/60 origin-left" data-id="element-394" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}